import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=55f4ceca&scoped=true&"
import script from "./Panel.vue?vue&type=script&lang=js&"
export * from "./Panel.vue?vue&type=script&lang=js&"
import style0 from "./Panel.vue?vue&type=style&index=0&id=55f4ceca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4ceca",
  null
  
)

/* custom blocks */
import block0 from "./Panel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55f4ceca')) {
      api.createRecord('55f4ceca', component.options)
    } else {
      api.reload('55f4ceca', component.options)
    }
    module.hot.accept("./Panel.vue?vue&type=template&id=55f4ceca&scoped=true&", function () {
      api.rerender('55f4ceca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Panel.vue"
export default component.exports